// ---- Warenkorb-Seite: Mengenänderung und Löschen per AJAX statt vollem
// Seiten-Reload. Nutzt Shopifys /cart/change.js für die eigentliche
// Änderung, danach /cart?sections=main um den aktualisierten HTML-
// Ausschnitt zu holen (Section-Rendering-API) — Zwischensumme, Zeilen-
// preise UND die Versandkosten-Fortschrittsleiste (assets/nexus-base.css:
// .cart-shipping-progress) sind serverseitig berechnet, ein reines
// JS-Update der Zahl allein würde diese nicht mitziehen.
(function initWarenkorbAjax() {
  var itemsWrapper = document.querySelector('.cart-page-items');
  if (!itemsWrapper) return;

  var ladeAktiv = false;

  function ladeZustandSetzen(aktiv) {
    ladeAktiv = aktiv;
    var wurzel = document.querySelector('.cart-page-layout');
    if (wurzel) wurzel.classList.toggle('is-aktualisiert-wird', aktiv);
  }

  // War: nur e.preventDefault() im Klick-Handler, um die href-Links zu
  // stoppen. Genau wie beim Sidebar-Panel (siehe nexus-base.js,
  // cartPanelHrefsEntfernen) reichte das bei mehreren Klicks nicht
  // zuverlässig — nach dem ersten innerHTML-Austausch konnte der Browser
  // bei einem der nächsten Klicks trotzdem zum alten href navigieren
  // (ein kompletter Seiten-Reload, der mehrere Sekunden dauert und
  // erklärt, warum es sich anfühlte, als würde "gar nichts" oder erst
  // nach vielen Klicks etwas passieren). Jetzt wird das href aktiv
  // entfernt, sobald JS aktiv ist und nach jedem Update erneut — dann
  // gibt es für den Browser gar kein Linkziel mehr, das er navigieren
  // könnte, unabhängig vom Timing des Event-Handlers.
  function warenkorbHrefsEntfernen() {
    itemsWrapper.querySelectorAll('.qty-minus, .qty-plus, .cart-page-item-remove').forEach(function (btn) {
      btn.removeAttribute('href');
    });
  }
  warenkorbHrefsEntfernen();

  function mengeAendern(line, neueMenge) {
    if (ladeAktiv) return;
    ladeZustandSetzen(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: neueMenge })
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('Änderung fehlgeschlagen');
        return antwort.json();
      })
      .then(function (warenkorb) {
        // item_count für den Header-Zähler merken — die Section-Antwort
        // unten enthält NUR die Warenkorb-Section, nicht den Header.
        if (warenkorb && typeof warenkorb.item_count === 'number') {
          var badge = document.querySelector('#cartCountBadge');
          if (badge) badge.textContent = warenkorb.item_count;
        }
        return warenkorb;
      })
      .then(function () {
        // War: ?section_id=main — falscher Parametername, Shopifys
        // Section-Rendering-API erwartet 'sections' (Mehrzahl), nicht
        // 'section_id'. Der falsche Parameter führte zuverlässig zu
        // einem 404 bei JEDEM Löschversuch (siehe Konsolen-Screenshot:
        // "Failed to load resource: 404 — /cart?section_id=main"), die
        // Anfrage landete dann im catch-Block, der die Seite neu lud —
        // was sich wie "manchmal 10 Sekunden" oder "reagiert gar nicht"
        // anfühlte, je nachdem wie schnell der Reload durchlief.
        // Die Antwort ist außerdem JSON ({"main": "<html>..."}), kein
        // direktes HTML wie bei einem normalen Seitenaufruf.
        //
        // WEITERER FUND: "main" allein war noch immer falsch. Shopify
        // vergibt bei JSON-Templates (wie templates/cart.json) IDs mit
        // einem Template-Präfix, z.B. "template--30010578928003__main"
        // statt nur "main" — sichtbar am umschließenden Element
        // <div id="shopify-section-template--...__main">. Eine Anfrage
        // mit dem falschen Namen "main" bekam von Shopify zwar ein
        // gültiges { main: null } zurück (kein Fehler, kein 404), aber
        // der Wert war leer — der Klick wirkte dadurch komplett
        // wirkungslos, ganz ohne jede Fehlermeldung in der Konsole.
        // Die ID daher direkt aus der Seite selbst auslesen, statt sie
        // fest im Code zu hinterlegen.
        var sectionElement = document.querySelector('[id^="shopify-section-"]');
        var sectionId = sectionElement
          ? sectionElement.id.replace('shopify-section-', '')
          : 'main';
        return fetch(window.location.pathname + '?sections=' + sectionId).then(function (antwort) {
          return antwort.json().then(function (sections) {
            return { sections: sections, sectionId: sectionId };
          });
        });
      })
      .then(function (ergebnis) {
        var parser = new DOMParser();
        var neuesDokument = parser.parseFromString(ergebnis.sections[ergebnis.sectionId], 'text/html');
        // Die Section-Rendering-API liefert den Inhalt der Section direkt
        // zurück (<div class="container">...), OHNE den äußeren
        // <section class="cart-page-section">-Wrapper, der normalerweise
        // drumherum liegt. Der vorherige Selektor ".cart-page-section
        // .container" fand deshalb nichts — der innerHTML-Austausch lief
        // scheinbar fehlerfrei durch (keine Fehlermeldung), veränderte
        // aber nie etwas sichtbar Angezeigtes.
        // War: querySelector('.container') ohne Eingrenzung — traf immer
        // den ERSTEN .container im zurückgegebenen HTML. Die Section
        // "main" enthält aber ZWEI .container-Elemente: eines im Hero
        // (sections/warenkorb.liquid, <section class="page-hero">) und
        // eines im eigentlichen Warenkorb-Inhalt (<section
        // class="cart-page-section">). Der Hero-Container wurde
        // fälschlich in den Inhalts-Container eingefügt — der Hero
        // erschien dadurch nach jeder Löschung ein zweites Mal auf der
        // Seite. Jetzt gezielt der Container INNERHALB von
        // .cart-page-section, wie ursprünglich beabsichtigt.
        var neuerLayoutBereich = neuesDokument.querySelector('.cart-page-section .container');
        var aktuellerLayoutBereich = document.querySelector('.cart-page-section .container');
        if (neuerLayoutBereich && aktuellerLayoutBereich) {
          aktuellerLayoutBereich.innerHTML = neuerLayoutBereich.innerHTML;
          // Wichtig: NICHT die alte itemsWrapper-Variable von oben
          // wiederverwenden — .cart-page-items liegt selbst INNERHALB des
          // gerade ersetzten .container-Bereichs und wurde mit ausgetauscht.
          // Frisch abfragen, sonst bleibt das href-Entfernen nach dem
          // ersten Update wirkungslos (genau das Muster, das beim
          // Sidebar-Panel bereits gefunden und behoben wurde).
          var neuerItemsBereich = document.querySelector('.cart-page-items');
          if (neuerItemsBereich) {
            neuerItemsBereich.querySelectorAll('.qty-minus, .qty-plus, .cart-page-item-remove').forEach(function (btn) {
              btn.removeAttribute('href');
            });
          }
        }
        // Der Header-Zähler wird weiter oben direkt aus der
        // /cart/change.js-Antwort (item_count) gesetzt — die hier geholte
        // Section-Antwort enthält den Header nicht, ein Griff hinein
        // fände #cartCountBadge nie.
        ladeZustandSetzen(false);
      })
      .catch(function () {
        // Bei einem Fehler lieber die Seite ganz normal neu laden, statt
        // den Kunden mit einem stillen, nicht aktualisierten Warenkorb
        // sitzen zu lassen.
        window.location.reload();
      });
  }

  // Klicks auf Mengen- und Löschen-Buttons abfangen, statt dem href zu folgen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-minus, .qty-plus, .cart-page-item-remove');
    if (!btn) return;
    var itemsBereich = document.querySelector('.cart-page-items');
    // Nach dem Löschen des letzten Artikels liefert der Server den leeren
    // Zustand zurück (kein .cart-page-items mehr im DOM) — ohne diese
    // Prüfung würde .contains() auf null einen Fehler werfen und den
    // Event-Listener beim nächsten Klick stillschweigend lahmlegen.
    if (!itemsBereich || !itemsBereich.contains(btn)) return;

    e.preventDefault();
    var line = btn.getAttribute('data-line');
    var neueMenge = btn.getAttribute('data-neue-menge');
    if (!line || neueMenge === null) return;

    // Kernbauteil-Schutz: Konfigurations-Positionen nicht ohne Rückfrage
    // entfernen — sonst ist das System hinterher unbemerkt unvollständig.
    // War: window.confirm() (grauer Browser-Kasten) — jetzt der NEXUS-
    // Dialog aus nexus-base.js, mit eigenem Wortlaut für die Montage.
    // confirm() bleibt als Fallback, falls nexus-base.js nicht geladen ist.
    if (btn.classList.contains('cart-page-item-remove')) {
      var zeile = btn.closest('.cart-page-item');
      if (zeile && zeile.classList.contains('ist-konfiguration')) {
        var frage = window.nexusBestaetigen || function (optionen) {
          return Promise.resolve(window.confirm(optionen.titel + ' ' + optionen.text));
        };
        var wortlaut = window.nexusKonfigEntfernenDialog
          ? window.nexusKonfigEntfernenDialog(zeile.getAttribute('data-zusatz-art'))
          : {
              titel: 'Teil deiner PC-Konfiguration',
              text: 'Ohne diesen Artikel ist dein System unvollständig. Wirklich entfernen?',
              okText: 'Entfernen',
              abbrechenText: 'Behalten'
            };
        frage(wortlaut).then(function (bestaetigt) {
          if (bestaetigt) mengeAendern(parseInt(line, 10), parseInt(neueMenge, 10));
        });
        return;
      }
    }

    mengeAendern(parseInt(line, 10), parseInt(neueMenge, 10));
  });
})();


// ---- Gewaehrleistungslabel: vergroesserte Ansicht (Overlay) ----
// Klick auf das Label im Warenkorb oeffnet es gross und lesbar; schliessen
// per Klick irgendwo, X oder Escape. Sanfter Effekt ueber CSS-Klasse.
(function () {
  var knopf = document.getElementById('gwlZoomKnopf');
  var overlay = document.getElementById('gwlOverlay');
  if (!knopf || !overlay) return;
  var schliessKnopf = document.getElementById('gwlOverlaySchliessen');

  function oeffnen() {
    overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('ist-offen'); });
    });
    document.addEventListener('keydown', beiTaste);
  }

  function schliessen() {
    overlay.classList.remove('ist-offen');
    document.removeEventListener('keydown', beiTaste);
    window.setTimeout(function () { overlay.hidden = true; }, 260);
    knopf.focus();
  }

  function beiTaste(e) { if (e.key === 'Escape') schliessen(); }

  knopf.addEventListener('click', oeffnen);
  overlay.addEventListener('click', schliessen);
  if (schliessKnopf) schliessKnopf.addEventListener('click', function (e) { e.stopPropagation(); schliessen(); });
})();
